<template>
  <v-row>
    <v-col class="px-6">
      <v-card elevation="4" width="100%">
        <v-card-title>
          <span>
            Total visitors and pageviews
          </span>

          <v-spacer />
          <v-img
            max-height="100"
            max-width="200"
            contain
            class="mx-auto"
            :src="require('../assets/google-analytics-logo.jpg')"
          ></v-img>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="mostVisitedPages"
          :items-per-page="10"
          :loading="loading"
        ></v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { axios } from '../utils'
export default {
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'date'
        },
        {
          text: 'Visitors',
          align: 'start',
          sortable: true,
          value: 'visitors'
        },
        {
          text: 'Views',
          align: 'start',
          sortable: true,
          value: 'pageViews'
        }
      ],
      mostVisitedPages: []
    }
  },
  mounted() {
    axios
      .get('/api/admin/analytics/total-visitors-and-page-views')
      .then(({ data }) => (this.mostVisitedPages = data))
      .then(err => console.log(err))
  }
}
</script>

<style></style>
